/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-07-16 15:06:36
 * @LastEditTime: 2025-07-28 09:38:30
 * @LastEditors: sudo_rm_rf
 */

import { useUser } from '/@/store';

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    const { value } = binding;
    const all_permission = '*:*:*';
    const permissions = useUser().permissions;

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;

      const hasPermissions = permissions.some((permission: string) => {
        return all_permission === permission || permissionFlag.includes(permission);
      });

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      console.log(el);
      console.log(binding);
      throw new Error(`请设置操作权限标签值`);
    }
  },
};
